module.exports = __webpack_public_path__ + "static/stats@2x-ba8f5ec53dfbe71cf415b69a4f9024cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/stats@2x.jpg
// module id = 445
// module chunks = 3627797113349 20562973939449 33019919093843